import React from "react";
import { Col } from "antd";

const WinPointsTeam = () => {
    return (
      <Col style={{ marginTop: "30px" }}>
        <Col
          span={12}
          style={{ textAlign: "center", color: "#0000FE", fontSize: "18px" }}
        >
          <h3 style={{ color: "black", fontSize: "24px" }}>Obtenir des points</h3>
          <p>Cours collectif donné</p>
          <p>Cours particulier accepté</p>
          <p>Nouveau client</p>
          <p>Absence / Cours annulé </p>
        </Col>
        <Col span={12} style={{ textAlign: "center", fontSize: "18px" }}>
          <h3 style={{ color: "black", fontSize: "24px" }}>Points gagnés</h3>
          <p>10</p>
          <p>10</p>
          <p>50</p>
          <p>-50 </p>
        </Col>
      </Col>
    );
}

export default WinPointsTeam;
